import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'relative',
		imageStyle: 'max-sm:min-h-screen sm:aspect-[1.2] lg:aspect-[16/9] w-full h-full object-cover',
		textOverlay:
			'absolute top-0 left-0 w-full h-full flex justify-center items-center px-2 lg:px-4',
		title: 'max-w-[32rem] md:max-w-max',
		svgStyles: 'absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-[80%] md:w-[70%] lg:max-w-[60rem] xl:max-w-[80rem]',
	},
})

export type ImageHighlightVariants = VariantProps<typeof styles>
